<template>
  <div class="profile">
    <div class="main-wrapper">
      <layout-headerApp></layout-headerApp>
      <!-- Page Wrapper -->
      <div
        class="page-wrapper job-wrapper"
        style="font-family: 'Quicksand', sans-serif;
        font-size: .9375rem;
        color: #1f1f1f;
        background-color: #f7f7f7;
        min-height: 100%;
        overflow-x: hidden;"
      >
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
                v-if="message"
              >
                <strong>Success!</strong> {{ message }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{
                                applicant.firstName + " " + applicant.lastName
                              }}
                            </h3>
                            <h6 class="text-muted">{{ applicant.email }}</h6>
                            <div class="staff-id">
                              Gender : {{ applicant.gender }}
                            </div>
                            <div class="small doj text-muted">
                              Contact : {{ applicant.phone1 }}
                            </div>
                            <!-- <div class="staff-msg">
                              <router-link to="/chat" class="btn btn-custom"
                                >Send Message
                              </router-link>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-5">
                          <ul class="personal-info">
                            <li>
                              <div class="title-label">Contact:</div>
                              <div class="text">
                                {{ applicant.phone1 }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Alt Contact:</div>
                              <div class="text">{{ applicant.phone2 }}</div>
                            </li>
                            <li>
                              <div class="title-label">Experience:</div>
                              <div class="text">
                                <a href="">{{
                                  applicant.experience + " years"
                                }}</a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-content">
            <!-- Profile Info Tab -->
            <div
              id="emp_profile"
              class="pro-overview tab-pane fade show active"
            >
              <div class="row">
                <div class="col-md-6 u-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Experience
                        <a href="#" class="edit-icon" @click="openExperience"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in applicant.applicantExperiences"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  item.companyName
                                }}</a>
                                <div>{{ item.position }}</div>
                                <span class="time"
                                  >{{
                                    new Date(item.startYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{ new Date(item.startYear).getFullYear() }} -
                                  {{
                                    new Date(item.endYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{
                                    new Date(item.endYear).getFullYear()
                                  }}</span
                                >
                                <hr />
                                <span>{{ item.description }}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Education Informations
                        <a href="#" class="edit-icon" @click="openEducation"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in applicant.applicantEducations"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  item.institute
                                }}</a>
                                <div>{{ item.discipline }}</div>
                                <span class="time"
                                  >{{
                                    new Date(item.startYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{ new Date(item.startYear).getFullYear() }} -
                                  {{
                                    new Date(item.endYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{
                                    new Date(item.endYear).getFullYear()
                                  }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <h3 class="card-title">
                    Applications
                  </h3>

                  <div class="card" v-for="item in app" :key="item.id">
                    <router-link :to="`/appdetail/${item.id}`">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-9">
                            <span style="mb-2">{{
                              new Date(item.createdAt).toLocaleDateString()
                            }}</span>
                            <h4>{{ item.vacancy.jobProfile.title }}</h4>
                          </div>
                          <div class="col-md-3">
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 0"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-purple"></i>
                              Processing
                            </a>

                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 6"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-purple"></i>
                              Unqualified
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 1"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-success"></i>
                              Accepted
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 2"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-info"></i> Test
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 3"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-info"></i>
                              Interview Scheduling
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 4"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-info"></i>
                              Interview
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 5"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-info"></i>
                              Negotiation
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 6"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-info"></i>
                              Medical
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 8"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i>
                              Rejected
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.status == 20"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i>
                              Uncompleted
                            </a>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Profile Info Tab -->
          </div>
        </div>
        <!-- /Page Content -->
        <experience-modal
          :model="applicant.applicantExperiences"
          :id="applicant.id"
          :dialog="experienceDialog"
          v-if="experienceDialog"
          :method="closeExperience"
        ></experience-modal>
        <education-modal
          :model="applicant.applicantEducations"
          :id="applicant.id"
          :dialog="educationDialog"
          v-if="educationDialog"
          :method="closeEducation"
        ></education-modal>
        <skill-modal
          :model="skillLevels"
          :grades="skillGrades"
          :id="app.id"
          :skillId="0"
          :dialog="skillDialog"
          v-if="skillDialog"
          :method="FinishApplying"
        ></skill-modal>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeaderApp from "@/components/layouts/HeaderApp.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import ExperienceModal from "@/components/career/ExpModal.vue";
import EducationModal from "@/components/career/EduModal.vue";
import SkillModal from "@/components/career/SkillModal.vue";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import { jobService } from "@/services/jobService.js";
import { applicantService } from "@/services/applicantService.js";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeaderApp,
    LayoutSidebar,
    ExperienceModal,
    EducationModal,
    SkillModal,
    Datepicker
  },
  data() {
    return {
      experienceDialog: false,
      educationDialog: false,
      skillDialog: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      message: "",
      error: "",
      file: null,
      media: "data:image/jpeg;base64,",
      myAccount: false,
      skillLevels: [],
      skillGrades: [],
      applicant: {
        id: parseInt(this.$route.params.id),
        applicantEducations: [],
        applicantExperiences: []
      },
      app: []
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.GetApplicant();
      this.GetApplication();
      console.log(this.currentUser);
    } else {
      this.$route.push("/applicant-login");
    }
    // Date Time Picker
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // if ($(".floating").length > 0) {
    //   $(".floating")
    //     .on("focus blur", function (e) {
    //       $(this)
    //         .parents(".form-focus")
    //         .toggleClass(
    //           "focused",
    //           e.type === "focus" || this.value.length > 0
    //         );
    //     })
    //     .trigger("blur");
    // }
  },
  methods: {
    openEducation() {
      this.educationDialog = true;
      console.log(this.educationDialog);
    },
    openExperience() {
      this.experienceDialog = true;
    },
    closeEducation(complete) {
      if (complete) {
        applicantService.getApplicant(this.applicant.id).then(
          model => {
            this.applicant = model;
            this.educationDialog = false;
          },
          error => {
            this.error = error;
          }
        );
      } else {
        this.educationDialog = false;
      }
    },
    closeExperience(complete) {
      if (complete) {
        applicantService.getApplicant(this.applicant.id).then(
          model => {
            this.applicant = model;
            this.experienceDialog = false;
          },
          error => {
            this.error = error;
          }
        );
      } else {
        this.experienceDialog = false;
      }
    },
    GetApplication() {
      jobService.getAllApplicationsByApplicant(this.applicant.id).then(
        model => {
          this.app = model;
        },
        error => {
          this.error = error;
        }
      );
    },
    GetApplicant() {
      applicantService.getApplicant(this.applicant.id).then(
        model => {
          this.applicant = model;
        },
        error => {
          this.error = error;
        }
      );
    }
  },
  name: "appdetail"
};
</script>



// WEBPACK FOOTER //
// src/components/career/applicant.vue